import { render, staticRenderFns } from "./margePrice.vue?vue&type=template&id=6c4863ab"
import script from "./margePrice.vue?vue&type=script&lang=js"
export * from "./margePrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports